"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var uuid = require('uuid');

var SoulModule = require('./SoulModule');

var Phone = require('./Phone');

var Email = require('./Email');

var _Promise = require('bluebird');

var Keycloak = require('./Keycloak');
/**
* SignIn, retention is important for viral grow
* @extends SoulModule
*/


var Auth =
/*#__PURE__*/
function (_SoulModule) {
  _inherits(Auth, _SoulModule);

  function Auth(data, me) {
    var _this;

    _classCallCheck(this, Auth);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Auth).call(this, data));
    /**
    * phone
    * @see Phone
    * @public
    */

    _this.phone = new Phone(data);
    _this.email = new Email(data);
    _this.keycloak = new Keycloak(data, me);
    _this._me = me;
    return _this;
  }
  /**
  * Check authentication
  * @param {boolean} _
  * @param {function} [callback]
  * Function to execute after checking 
  * @return {Promise}
  * @soulsdk soul.auth.isAuthenticated
  * @example soul.auth.isAuthenticated(() => {})
  */


  _createClass(Auth, [{
    key: "isAuthenticated",
    value: function () {
      var _isAuthenticated = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(_, callback) {
        var _this2 = this;

        var accessToken, isAuthenticated, mePromise;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.storage.get('deviceId')) {
                  this.generateDeviceId();
                }

                this.storage.set('newAuth', true);
                accessToken = this.storage.get('accessToken');
                isAuthenticated = false;

                if (accessToken) {
                  // user is authenticated
                  isAuthenticated = true;
                }

                if (!isAuthenticated) {
                  _context.next = 9;
                  break;
                }

                mePromise = this._me.get(callback);
                mePromise.then(function (res) {
                  return _this2.storage.saveSession({
                    me: res.me
                  });
                })["catch"](function () {
                  return _this2.storage.removeSession();
                });
                return _context.abrupt("return", mePromise);

              case 9:
                return _context.abrupt("return", _Promise.reject(new Error('unauthorized')));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function isAuthenticated(_x, _x2) {
        return _isAuthenticated.apply(this, arguments);
      }

      return isAuthenticated;
    }()
    /**
    * signOut
    * @soulsdk soul.auth.signOut
    * @example soul.auth.signOut()
    */

  }, {
    key: "signOut",
    value: function signOut() {
      var _this3 = this;

      var logoutRequestPromise = this.api.post('auth/logout');
      this.eventEmitter.emit('logout');
      logoutRequestPromise.then(function () {
        return _this3.storage.removeSession();
      });
      return logoutRequestPromise;
    }
    /**
    * Auth request handler
    * @param {Object} params
    * @param {string} [params.phoneNumber] User phone number
    * @param {string} [params.email] User email
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.auth.request
    * @example soul.auth.request({ 
    *   phoneNumber: '+79991213123'
    * })
    *  @example soul.auth.request({ 
    *   email: 'soul@pure.com'
    * })
    */

  }, {
    key: "request",
    value: function request() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (params.email) {
        return this.email.request(params);
      }

      if (params.phoneNumber) {
        return this.phone.getCode(params);
      }

      return _Promise.reject('Required auth fields not found');
    }
    /**
    * Auth verification handler. One of two params email and phone is required bun not both
    * @param {Object} params
    * @param {Object} params.code verification code from email or phone
    * @param {Object} [params.email] email to verify
    * @param {Object} [params.phoneNumber] phone to verify
    * @return {Promise}
    * @soulsdk soul.auth.verify
    * @example soul.auth.verify({ 
    *   email: 'soul@pure.com',
    *   code: 12345,
    * })
    * 
    * @example soul.auth.verify({ 
    *   phoneNumber: '+79991213123'
    *   code: 12345,
    * })
    */

  }, {
    key: "verify",
    value: function verify() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var email = params.email || this.storage.get('email');

      var _JSON$parse = JSON.parse(this.storage.get('phoneVerification') || '{}'),
          phoneNumber = _JSON$parse.phoneNumber;

      if (email) {
        return this.email.verify(params);
      }

      if (phoneNumber || params.phoneNumber) {
        return this.phone.verify(params);
      }

      return _Promise.reject('Auth method is not selected');
    }
    /**
    * Session recovery handler. One of two params email and phone is required bun not both
    * @param {Object} params
    * @param {Object} [params.email] email to verify
    * @param {Object} [params.phoneNumber] phone to verify
    * @param {string} [params.lastSessionToken]
    * Apply lastSessionToken from storage if not specified
    * @param {function} [callback] Function that will execute after session recovery
    * @return {Promise}
    * @soulsdk soul.auth.recoverSession
    * @example soul.auth.recoverSession({ 
      *   email: 'soul@pure.com',
      *   lastSessionToken: '26d6a3a5-417c-40e9-b74f-3ddb6bf3ff70'
      * }, () => { 
      *   // do something 
      * })
      * 
      * @example soul.auth.recoverSession({ 
      *   phoneNumber: '+79991213123'
      *   lastSessionToken: '26d6a3a5-417c-40e9-b74f-3ddb6bf3ff70'
      * })
      */

  }, {
    key: "recoverSession",
    value: function recoverSession() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      var email = params.email || this.storage.get('email');
      var phoneNumber = params.phoneNumber || JSON.parse(this.storage.get('phoneVerification') || '{}').phoneNumber;

      if (email) {
        return this.email.recoverSession({
          email: email
        }, callback);
      }

      if (phoneNumber) {
        return this.phone.recoverSession({
          phoneNumber: phoneNumber
        }, callback);
      }

      return callback(true);
    }
  }, {
    key: "generateDeviceId",
    value: function generateDeviceId() {
      this.storage.set('deviceId', uuid().toString());
    }
  }, {
    key: "authViaGoogle",
    value: function authViaGoogle(code, redirect_url) {
      var _this4 = this;

      return this.api.post('auth/google/verify', {
        code: code,
        redirect_url: redirect_url,
        apiKey: this.apiKey
      }).then(function (data) {
        _this4.storage.set('email', data.me ? data.me.email : '');

        _this4.storage.saveSession(data);

        window.localStorage.removeItem('anonymous_user');
        return data;
      });
    }
  }, {
    key: "authViaApple",
    value: function authViaApple(token, code, email) {
      var _this5 = this;

      if (email) {
        this.storage.set('email', email);
      }

      return this.api.post('auth/apple/verify', _objectSpread({
        code: code,
        id_token: token,
        apiKey: this.apiKey,
        type: 'web'
      }, email && {
        email: email
      })).then(function (data) {
        _this5.storage.saveSession(data);

        if (!email && data.me.email) {
          _this5.storage.set('email', data.me.email);
        }

        window.localStorage.removeItem('anonymous_user');
        return data;
      });
    }
  }, {
    key: "authViaHuawei",
    value: function authViaHuawei(code, redirect_url) {
      var _this6 = this;

      return this.api.post('auth/huawei/verify', {
        code: code,
        redirect_url: redirect_url,
        apiKey: this.apiKey
      }).then(function (data) {
        _this6.storage.set('email', data.me ? data.me.email : '');

        _this6.storage.saveSession(data);

        window.localStorage.removeItem('anonymous_user');
        return data;
      });
    }
  }, {
    key: "getVoximplantCredentials",
    value: function getVoximplantCredentials() {
      return this.api.get('voximplant/credentials');
    }
  }]);

  return Auth;
}(SoulModule);

module.exports = Auth;